module.exports = __webpack_public_path__ + "static/media/61.7559f834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/61.jpg
// module id = 621
// module chunks = 0